import { Box, Grid, IconButton, Tooltip } from '@mui/material';
import QuestionsChat from './QuestionsChat';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { ReactComponent as CollapseIcon } from '../../../src/assets/collapse.svg';
import { ReactComponent as ExpandIcon } from '../../../src/assets/expand.svg';
import { useState } from 'react';

const Toolbar = ({ expanded, onExpand }) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', paddingX: 2, paddingY: 1.5 }}>
      {expanded ? (
        <Tooltip title="Collapse">
          <IconButton aria-label="collapse" onClick={onExpand}>
            <CollapseIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip title="Expand">
          <IconButton aria-label="expand" onClick={onExpand}>
            <ExpandIcon />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

const ChatDrawer = ({ sessionId, selectedSegment, isSessionOwner, open, onClose }) => {
  const [expanded, setExpanded] = useState(true);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: open ? (expanded ? 'calc(100vh - 250px)' : 'calc(100vh - 390px)') : 0,
        borderRadius: '20px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.25)',
        transition: (theme) =>
          theme.transitions.create('height', {
            easing: theme.transitions.easing.sharp,
            duration: '100ms',
          }),
      }}>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: '50%',
          transform: 'translate(-50%, -50%)',
          opacity: 0,
          ...(open && {
            opacity: 1,
            transition: 'opacity 0.5s ease-in-out',
          }),
        }}>
        <IconButton
          aria-label="close chat"
          onClick={() => onClose(false)}
          sx={{
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.25)',

            '&:hover': {
              backgroundColor: '#FFFFFF',
              color: (theme) => theme.palette.secondary.main,
            },
          }}>
          <CloseRoundedIcon />
        </IconButton>
      </Box>
      <Grid
        container
        flexDirection="column"
        sx={{ height: 'inherit', borderRadius: '20px', overflow: 'hidden', flexWrap: 'nowrap' }}>
        <Grid item>
          <Toolbar expanded={expanded} onExpand={handleExpandClick} />
        </Grid>
        <Grid item sx={{ flexGrow: 1 }}>
          <QuestionsChat
            sessionId={sessionId}
            selectedSegment={selectedSegment}
            isSessionOwner={isSessionOwner}
            showToolbar={true}
            showCarousel={true}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ChatDrawer;
